import ApplicationController from './application_controller'

/* This is the custom StimulusReflex controller for the Posts Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  static targets = [ "changeloglink" ]

  connect () {
    this.lastUpdate = this.element.dataset.lastupdate.replace(/\-/g, '');
    console.log("Connected to ChangelogController " + this.lastUpdate);
    this.hightlightChanges();

  }
  hightlightChanges() {
    // Calculate date 30 days ago
    const today = new Date();
    const thirtyDaysAgo = new Date(today);
    thirtyDaysAgo.setDate(today.getDate() - 30);
    const thirtyDaysAgoFormatted = `${thirtyDaysAgo.getFullYear()}-${thirtyDaysAgo.getMonth()+1}-${thirtyDaysAgo.getDate()}`;

    let dt = new Date();
    let dateToday = `${dt.getFullYear()}${dt.getMonth()+1}${dt.getDate()}`;
    console.log("date " + dateToday + " value " + this.lastUpdate);

    if (thirtyDaysAgoFormatted <= this.lastUpdate) {
      console.log("now highlighting")
      this.changeloglinkTarget.classList.add("highlight");
      this.changeloglinkTarget.insertAdjacentHTML('beforeend', '<span class="badge badge-primary ml-4">Neue Updates!</span>');
    }
  }
  showVersion(event) {
    let versionString = event.target.value;
    const url = new URL(window.location.href);
    url.searchParams.set('clversion', versionString);

    window.location.href = url;
  }
}
